import { useSelector } from 'react-redux';
import { RootState } from 'redux/types';
import { WELL_PLANS_LIST_FILTERS, WellPlansListFiltersState } from 'types/filters';
import { WellPlanDTO } from 'types/wellPlan';

const getWellPlans = (store: RootState) => store.performance.wellPlans;
export const useSelectWellPlans = () => useSelector(getWellPlans);

const getLessonLearntAvailableCategories = (store: RootState) =>
  store.performance.lessonLearntAvailableCategories;
export const useSelectLessonLearntAvailableCategories = () =>
  useSelector(getLessonLearntAvailableCategories);

export const getFilteredWellPlans =
  (filtersState: WellPlansListFiltersState) => (store: RootState) => {
    const isFilteredByFilter = (wellplan: WellPlanDTO, filter: WELL_PLANS_LIST_FILTERS) => {
      const wellPlanFilter: string = [wellplan[filter]].filter(
        (value: string | null): value is string => value !== null,
      )[0];

      return filtersState[filter].length === 0 || filtersState[filter].includes(wellPlanFilter);
    };

    return store.performance.wellPlans.filter(wellplan => {
      let isFiltered = true;
      (Object.keys(filtersState) as Array<WELL_PLANS_LIST_FILTERS>).forEach(key => {
        isFiltered = isFiltered && isFilteredByFilter(wellplan, key);
      });

      return isFiltered;
    });
  };

type Option = { label: string; value: string };

export const getWellPlansFilterOptions = (store: RootState): Record<string, Option[]> => {
  const wellPlans = store.performance.wellPlans;
  const formatStringToOption = (values: string[]) => values.map(value => ({ label: value, value }));
  const getSelectedFilterOnly = (filter: WELL_PLANS_LIST_FILTERS) =>
    wellPlans
      .map((wellPlan: WellPlanDTO) => wellPlan[filter])
      .filter((filter: string | null): filter is string => filter !== null);
  const getOptions = (filter: WELL_PLANS_LIST_FILTERS): Option[] =>
    formatStringToOption([...new Set(getSelectedFilterOnly(filter))]);

  return {
    name: getOptions(WELL_PLANS_LIST_FILTERS.NAME),
    tuwi: getOptions(WELL_PLANS_LIST_FILTERS.TUWI),
    country: getOptions(WELL_PLANS_LIST_FILTERS.COUNTRY),
    affiliate: getOptions(WELL_PLANS_LIST_FILTERS.AFFILIATE),
  };
};
